module.exports = __webpack_public_path__ + "static/media/FCE.d8c83749.svg";